import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { showApiErrorToast } from '@/utils/errors';
import { deleteInstituteType, instituteTypeQueryKeys } from '../api/instituteTypes.api';

export function useDeleteInstituteType() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => deleteInstituteType(id),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: instituteTypeQueryKeys.all() });
      toast.success('Institute type deleted successfully');
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to delete institute type');
    },
  });
}
